
import { defineComponent, PropType } from 'vue'
import { DEFAULT_SIDEBAR_ITEM_SPACING, SPACING_CLASS_MAP, SpacingValue } from './spacing'

export default defineComponent({
  name: 'SidebarCollapsible',
  data() {
    return {
      collapsed: false
    }
  },
  props: {
    title: { type: String, default: '' },
    icon: {
      type: String,
      default: 'star-filled'
    },
    /**
     * Spacing between items using Tailwind's spacing scale
     * Default: '2.5' (10px)
     * Use '1' for 4px spacing (e.g., primary sidebar)
     */
    spacing: {
      type: String as PropType<SpacingValue>,
      default: DEFAULT_SIDEBAR_ITEM_SPACING
    }
  },
  computed: {
    spacingClass(): string {
      return (
        SPACING_CLASS_MAP[this.spacing as SpacingValue] ||
        SPACING_CLASS_MAP[DEFAULT_SIDEBAR_ITEM_SPACING]
      )
    }
  }
})
